import type { OfertaResponse } from '../../../store/MSCommerce/Ofertas/types';

export function getOfertaBadge(oferta: OfertaResponse): string {
  switch (oferta.tipo) {
    case 'PORCENTAJE':
      return `-${oferta.valor}%`;
    case 'MONTO_FIJO':
      return `-$${oferta.valor}`;
    case '2x1':
      return '2x1';
    default:
      return '';
  }
}

export function getDiasRestantes(fechaFin: Date | null): number | null {
  if (!fechaFin) return null;
  const fin = new Date(fechaFin).getTime();
  const ahora = Date.now();
  const dias = Math.ceil((fin - ahora) / (1000 * 60 * 60 * 24));
  return dias;
}

export function formatFecha(fecha: Date | null): string {
  if (!fecha) return '';
  return new Date(fecha).toLocaleDateString('es-EC', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function getAplicaANombres(oferta: OfertaResponse): string {
  const nombres = oferta.detalles
    .map(d => d.nombreReferencia)
    .filter((n): n is string => !!n);
  if (nombres.length === 0) return oferta.aplicaA === 'CATEGORIA' ? 'Categorías seleccionadas' : 'Productos seleccionados';
  return nombres.join(', ');
}

export function getEstadoLabel(oferta: OfertaResponse): { label: string; kind: 'activa' | 'inactiva' | 'expirada' | 'programada' } {
  const ahora = Date.now();
  const inicio = new Date(oferta.fechaInicio).getTime();
  const fin = oferta.fechaFin ? new Date(oferta.fechaFin).getTime() : null;

  if (oferta.status !== 'ACTIVO') return { label: 'Inactiva', kind: 'inactiva' };
  if (fin !== null && fin < ahora) return { label: 'Expirada', kind: 'expirada' };
  if (inicio > ahora) return { label: 'Programada', kind: 'programada' };
  return { label: 'Activa', kind: 'activa' };
}
